import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../../utils/utilNumber";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { TextLoca } from "../../generic/text/TextLoca";
export var OfferBadgeWebBonus = function (_a) {
    var bonusGold = _a.bonusGold, _b = _a.className, className = _b === void 0 ? "" : _b, idLoca = _a.idLoca;
    if (bonusGold == undefined || bonusGold === 0) {
        // tslint:disable-next-line:no-null-keyword
        return null;
    }
    var webBonusGoldReplacements = new Map([
        [ReplacementLoca.zero_0, utilNumber.format(bonusGold || 0)],
    ]);
    return (React.createElement("div", { className: IdStyles.OfferBonusLarge + " " + className },
        React.createElement("div", { className: "mr__small" },
            React.createElement(Icon, { icon: IdIcon.GoldIcn, styleId: IdStyles.IconSmall })),
        React.createElement(TextLoca, { className: IdStyles.TextBoldSecondaryOutline, id: idLoca, replacements: webBonusGoldReplacements })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/OfferBadgeWebBonus.tsx
// module id = 613
// module chunks = 3